<template>
    <public-ask-for-quote-layout>
        <Head>
            <title>Login</title>
        </Head>
        <div class="public-ask-for-quote">
            <Stepper>
                <step icon="list-basket-checkmark" class-names="active" routing="public-ask-for-quote.1" />
                <step icon="lock-shield-prote" class-names="active current">
                    <translate>Account</translate>
                </step>
                <step icon="delivery-shipment-packages-setting" />
                <step icon="credit-card-security-protection" />
            </Stepper>
            <div class="public-ask-for-quote--form">
                <AuthFormRegister :credentials="credentials" route="client.public-ask-for-quote.2.post" :headline="this.$gettext('Richten Sie Ihr Kundenkonto ein')" login-route="client.public-ask-for-quote.3" />
            </div>
        </div>
    </public-ask-for-quote-layout>
</template>

<script>
import PublicAskForQuoteLayout from '@partfactory/Layouts/PublicAskForQuoteLayout.vue';
import Stepper from '@partfactory/Shared/Stepper/Stepper.vue';
import Step from '@partfactory/Shared/Stepper/Step.vue';
import AuthFormRegister from '@partfactory/Pages/Client/Auth/AuthFormRegister.vue';

export default {
    name: 'PublicAskForQuote1',
    components: {
        AuthFormRegister,
        Step,
        Stepper,
        PublicAskForQuoteLayout,
    },
    props: {
        credentials: null,
    },
};
</script>
